import type { TableDisplayOptions } from './LayoutTable.vue';
import { fieldIdToCollectionFieldPath } from '#layers/data-model/public';

/**
 * Migrates the legacy `visibleColumnIds` key into `visibleColumnPaths` and drops it so it does not
 * linger in persisted display options through subsequent updates.
 *
 * Applies no defaults: keys the caller never set stay absent, so callers that persist the result
 * do not pin the view to synthesized values.
 */
export function migrateTableDisplayOptions(options?: TableDisplayOptions | null): TableDisplayOptions {
	const { visibleColumnIds, ...rest } = options ?? {};

	if (!visibleColumnIds || rest.visibleColumnPaths) return rest;

	return {
		...rest,
		visibleColumnPaths: visibleColumnIds.map((fieldId) => fieldIdToCollectionFieldPath(fieldId)),
	};
}
